import {
  saveGlobal,
  resetGlobal,
  resetAppGlobal,
} from './global';


let appResources = {}


// 非标准app，立即执行
function getUnformalApp(config) {
  const app = {
    async bootstrap() {
      console.log(`bootstrap:${config.id}`);
    },
    async mount() {
      console.log(`mount:${config.id}`);
      saveGlobal();
      const container = document.getElementById('container');
      container.innerHTML = config.html || '';
      for (const css of config.css) {
        const node = document.createElement('link');
        node.rel = 'stylesheet';
        node.async = true;
        node.href = css;
        container.appendChild(node);
      }
      for (const js of config.scripts) {
        const node = document.createElement('script');
        node.charset = 'utf-8';
        node.src = js;
        node.async = false;
        container.appendChild(node);
      }
    },
    async unmount() {
      console.log(`unmount:${config.id}`);
      const container = document.getElementById('container');
      container.innerHTML = '';
      resetGlobal();
    },
  };
  return {
    id: config.id,
    path: config.path,
    loadingFunction() {
      console.log(`loadingFunction,${this.name}`);
      return Promise.resolve().then(() => app);
    },
    type: config.type,
  };
}

function resetContainner(container,resources,appName){
  let eventBus = window.TNBL.eventBus
  container.innerHTML = resources.html || '';
  eventBus.dispatchGlobal("mfe-resetContainner",appName)
}

function formalLoadingFunc(config, orgWindowProperty) {
  // app内调用，可用this
  let eventBus = window.TNBL.eventBus
  const appName = this.name;
  console.log(`loadingFunction,${appName}`);
  eventBus.dispatchGlobal("mfe-loading",appName)
  return new Promise((resolve, reject) => {
    // 未加载新的app前，先保存沙箱环境
    saveGlobal();
    // 是否首次加载
    let isFirstLoad;
    // 当前app加载后（未执行mount），新增的全局变量，用于恢复
    let curAPPAddedGlobal;
    const vueGlobalAttr = ['$axios'];
    const vueGlobal = {};
    // 当前沙箱环境
    let curWindow = {};
    for (const a in window) {
      curWindow[a] = window[a];
    }
    let resources = appResources[config.id]
    window.System.import(resources.scripts.entry).then((m) => {
      console.log(`loadingFunction,had loaded:${appName}`);
      const orgBootstrap = m.bootstrap;
      const orgMount = m.mount;
      const orgUnmount = m.unmount;
      let orgStylesheet;
      const nm = {};
      nm.bootstrap = async function () {
        console.log(`bootstrap formal:${appName}`);
        eventBus.dispatchGlobal("mfe-bootstrap",appName)
        isFirstLoad = true;
        curAPPAddedGlobal = {};
        // 与两个沙箱对比，一个是原始沙箱，另一个是加载前的沙箱
        // 可能有问题，如果两个app之间加载顺序不可控，或者全局变量重写，将可能出错
        for (const a in window) {
          if (a in orgWindowProperty) {} else if (a in curWindow && curWindow[a] === undefined) { //
            curAPPAddedGlobal[a] = window[a];
          } else if (!(a in curWindow)) {
            curAPPAddedGlobal[a] = window[a];
          }
        }
        curWindow = undefined;
        // vue
        if (window.Vue) {
          for (const attr of vueGlobalAttr) {
            vueGlobal[attr] = window.Vue.prototype[attr];
          }
        }
        // 启动
        if (typeof orgBootstrap === 'function') {
          await orgBootstrap.apply(m, arguments);
        } else {
          for (const f of orgBootstrap) {
            await f.apply(m, arguments);
          }
        }
      };
      nm.mount = async function () {
        console.log(`mount formal:${appName}`);
        eventBus.dispatchGlobal("mfe-mount",appName)
        window.TNBL.eventBus.setAppName(appName);
        // 非首次加载，恢复上次的全局变量
        if (!isFirstLoad) {
          saveGlobal();
          resetAppGlobal(curAPPAddedGlobal);
          if (window.Vue) {
            for (const attr in vueGlobal) {
              window.Vue.prototype[attr] = vueGlobal[attr];
            }
          }
        } else {
          isFirstLoad = false;
        }
        // 加载css
        orgStylesheet = [...document.adoptedStyleSheets];
        const container = document.getElementById('container');
        if (!container) {
          return;
        }
        if (resources.css && resources.css.length) {
          for (let i = 0; i < resources.css.length; i++) {
            const css = resources.css[i];

            window.System.import(css).then(async function (module) {
              const styleSheet = module.default;
              document.adoptedStyleSheets = [...document.adoptedStyleSheets, styleSheet];
              if (i == 0) {
                // cssend
                resetContainner(container,resources,appName)
                if (typeof orgMount === 'function') {
                  await orgMount.apply(m, arguments);
                } else {
                  for (const f of orgMount) {
                    await f.apply(m, arguments);
                  }
                }
              }
            });
          }
        } else {
          // cssend
          resetContainner(container,resources,appName)
          if (typeof orgMount === 'function') {
            await orgMount.apply(m, arguments);
          } else {
            for (const f of orgMount) {
              await f.apply(m, arguments);
            }
          }
        }
      };
      nm.unmount = async function () {
        console.log(`unmount formal:${appName}`);
        eventBus.dispatchGlobal("mfe-unmount",appName)
        window.TNBL.eventBus.clearEventListener(appName);
        resetGlobal();
        const container = document.getElementById('container');
        if (!container) {
          return;
        }
        if (orgStylesheet) {
          document.adoptedStyleSheets = orgStylesheet;
          orgStylesheet = undefined;
        }
        if (typeof orgUnmount === 'function') {
          await orgUnmount.apply(m, arguments);
        } else {
          for (const f of orgUnmount) {
            await f.apply(m, arguments);
          }
        }
      };
      resolve(nm);
    })
      .catch((res) => {
        resetGlobal();
        reject(res);
      });
  });
}

function getFormalApp(config, orgWindowProperty) {
  return {
    id: config.id,
    path: config.path,
    loadingFunction() {
      return formalLoadingFunc.call(this, config, orgWindowProperty);
    },
    type: config.type,
  };
}

const globalOrgWindowProperty = {};
export function getApps(apps,isFromCheck) {
  // 保存最原始的window属性（未加载其他app前）
  if(!isFromCheck){
    for (const a in window) {
      globalOrgWindowProperty[a] = 1;
    }

  }

  const allApps = [];

  for (const k in apps) {
    const config = apps[k];
    if (config.type == 1) {
      const app = getUnformalApp(config);
      allApps.push(app);
    } else {
      const app = getFormalApp(config, globalOrgWindowProperty);
      allApps.push(app);
    }
  }
  return allApps;
}

//设置apps资源，并返回新的apps
export function setAppsResources(apps){
  let ars = appResources
  let newApps = {}
  for(let k in apps){
    if(!ars[k]){
      newApps[k] = apps[k]
    }
    ars[k] = apps[k]
  }
  return newApps
}